import React, { useState, useEffect } from "react";
import { useRole } from "@/hooks/useRole";
import { supabase } from "@/integrations/supabase/client";
import { SidebarContainer } from "./sidebar/SidebarContainer";

export const UniversalSidebar = () => {
  const { role, user } = useRole();
  const [nickname, setNickname] = useState<string | null>(null);
  
  useEffect(() => {
    // If we have user data with nickname from useRole, use that
    if (user?.nickname) {
      setNickname(user.nickname);
    } else if (role) {
      // Otherwise fetch it directly if user is logged in
      const fetchUserProfile = async () => {
        try {
          const { data: { session } } = await supabase.auth.getSession();
          if (session?.user) {
            const { data } = await supabase
              .from("profiles")
              .select("nickname")
              .eq("id", session.user.id)
              .single();
            
            if (data) {
              setNickname(data.nickname);
            }
          }
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      };
      
      fetchUserProfile();
    }
  }, [user, role]);

  return <SidebarContainer role={role} nickname={nickname} />;
};

export default UniversalSidebar;
